import { httpClient } from '../../http-client';
import { config } from '../../config';
export var fetchDeveloperPageData = function (companySlug, locale, rpcClient) {
    if (locale === void 0) { locale = 'en'; }
    return function () {
        var isSSR = typeof window === 'undefined';
        if (isSSR && rpcClient !== undefined) {
            return Promise.all([
                rpcClient.getCategories({ lang: locale }),
                rpcClient.getCompanies({ idsOrSlugs: companySlug, lang: locale }),
            ]).then(function (_a) {
                var categoryResponse = _a[0], companiesResponse = _a[1];
                return {
                    company: companiesResponse.companies[0],
                    categories: categoryResponse.categoryToSubCategory,
                };
            });
        }
        return Promise.all([
            httpClient.get(config.baseApiUrl + "/_api/marketplace-api/v1/categories?lang=" + locale),
            httpClient.get(config.baseApiUrl + "/_api/marketplace-api/v1/company/" + companySlug + "?lang=" + locale),
        ]).then(function (_a) {
            var _b, _c, _d;
            var categoryResponse = _a[0], companiesResponse = _a[1];
            return {
                company: (_c = (_b = companiesResponse === null || companiesResponse === void 0 ? void 0 : companiesResponse.data) === null || _b === void 0 ? void 0 : _b.companies) === null || _c === void 0 ? void 0 : _c[0],
                categories: (_d = categoryResponse === null || categoryResponse === void 0 ? void 0 : categoryResponse.data) === null || _d === void 0 ? void 0 : _d.categoryToSubCategory,
            };
        });
    };
};
//# sourceMappingURL=fetchDeveloperPageData.js.map